import React from "react";
import {
  Grid,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import clsx from "clsx";
import getTrans from "../../../languages/getTrans";
import {Link, useLocation} from "react-router-dom";

const homeActivePath = ['/'];
const searchActivePath = ['/services', '/services/:slug'];
const profileActivePath = ['/profile', '/settings', '/top-up-balance', '/top-up-balance/:id', '/top-up-balance/hash/:hash', '/balance-history'];
const myNumbersActivePath = ['/numbers-received'];

const isPathActive = (pathname, basePaths) => {
  if (basePaths.includes(pathname)) {
    return true;
  }
  return basePaths.some(basePath => {
    if (basePath === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(basePath + '/') || pathname === basePath;
  });
};

const Navigation = () => {
  const classes = useStyles();
  const location = useLocation();
  const locationPathname = location.pathname;

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <Link to="/" className={clsx({
            [classes.navigationItem]: true,
            '--active': isPathActive(locationPathname, homeActivePath),
          })}>
            <div className={classes.navigationItemIcon}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.1342 9.86992L16.2671 13.2069L17.4453 18.1973C17.5103 18.4682 17.4935 18.7523 17.3972 19.0137C17.3008 19.2751 17.1291 19.502 16.9038 19.6659C16.6785 19.8298 16.4097 19.9232 16.1313 19.9344C15.8529 19.9455 15.5775 19.874 15.3398 19.7287L10.9999 17.0577L6.65752 19.7287C6.41985 19.8731 6.14474 19.944 5.86685 19.9324C5.58895 19.9209 5.3207 19.8273 5.09587 19.6636C4.87104 19.4998 4.69968 19.2732 4.60336 19.0123C4.50705 18.7514 4.4901 18.4678 4.55463 18.1973L5.73713 13.2069L1.86995 9.86992C1.65966 9.68817 1.50757 9.4485 1.43268 9.18083C1.35779 8.91316 1.36342 8.62936 1.44887 8.36487C1.53431 8.10038 1.69578 7.86693 1.91311 7.69366C2.13044 7.52039 2.39401 7.41499 2.67088 7.39062L7.7412 6.98156L9.69713 2.24812C9.803 1.99015 9.98319 1.76949 10.2148 1.61419C10.4464 1.4589 10.7189 1.37598 10.9978 1.37598C11.2766 1.37598 11.5492 1.4589 11.7808 1.61419C12.0124 1.76949 12.1926 1.99015 12.2985 2.24812L14.2535 6.98156L19.3239 7.39062C19.6013 7.41409 19.8656 7.5189 20.0837 7.69192C20.3019 7.86495 20.4641 8.0985 20.55 8.36331C20.636 8.62812 20.6419 8.91241 20.5671 9.18057C20.4922 9.44873 20.3398 9.68882 20.1291 9.87078L20.1342 9.86992Z"/>
              </svg>
            </div>
            <div className={classes.navigationItemName}>{getTrans('header.Главная')}</div>
          </Link>
        </Grid>
        <Grid item xs={3}>
          <Link to="/numbers-received" className={clsx({
            [classes.navigationItem]: true,
            '--active': isPathActive(locationPathname, myNumbersActivePath),
          })}>
            <div className={classes.navigationItemIcon}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.2397 15.7333C19.0865 16.8977 18.5146 17.9666 17.6309 18.7403C16.7471 19.5139 15.612 19.9394 14.4375 19.9373C7.61407 19.9373 2.06251 14.3858 2.06251 7.56233C2.0604 6.38781 2.48591 5.25269 3.25956 4.36897C4.03321 3.48525 5.10209 2.91337 6.26657 2.76014C6.56104 2.72418 6.85924 2.78443 7.11665 2.93187C7.37407 3.07932 7.57689 3.30607 7.69485 3.57826L9.50985 7.63022C9.50951 7.63365 9.50951 7.6371 9.50985 7.64053C9.60016 7.84889 9.63746 8.07637 9.61841 8.30266C9.59937 8.52894 9.52457 8.74699 9.40071 8.93733C9.38524 8.96053 9.36891 8.98201 9.35173 9.0035L7.56251 11.1244C8.20618 12.4324 9.57431 13.7885 10.8995 14.4339L12.9912 12.6541C13.0117 12.6369 13.0332 12.6208 13.0556 12.606C13.2459 12.479 13.4649 12.4015 13.6926 12.3805C13.9204 12.3595 14.1499 12.3956 14.3602 12.4857L14.3705 12.4908L18.4181 14.305C18.691 14.4224 18.9185 14.625 19.0665 14.8824C19.2146 15.1399 19.2754 15.4384 19.2397 15.7333ZM12.375 6.18733H17.875C18.0573 6.18733 18.2322 6.11489 18.3611 5.98596C18.4901 5.85703 18.5625 5.68216 18.5625 5.49983C18.5625 5.31749 18.4901 5.14262 18.3611 5.01369C18.2322 4.88476 18.0573 4.81233 17.875 4.81233H12.375C12.1927 4.81233 12.0178 4.88476 11.8889 5.01369C11.7599 5.14262 11.6875 5.31749 11.6875 5.49983C11.6875 5.68216 11.7599 5.85703 11.8889 5.98596C12.0178 6.11489 12.1927 6.18733 12.375 6.18733ZM12.375 9.62483H17.875C18.0573 9.62483 18.2322 9.55239 18.3611 9.42346C18.4901 9.29453 18.5625 9.11966 18.5625 8.93733C18.5625 8.75499 18.4901 8.58012 18.3611 8.45119C18.2322 8.32226 18.0573 8.24983 17.875 8.24983H12.375C12.1927 8.24983 12.0178 8.32226 11.8889 8.45119C11.7599 8.58012 11.6875 8.75499 11.6875 8.93733C11.6875 9.11966 11.7599 9.29453 11.8889 9.42346C12.0178 9.55239 12.1927 9.62483 12.375 9.62483Z"/>
              </svg>
            </div>
            <div className={classes.navigationItemName}>{getTrans('header.Мои номера')}</div>
          </Link>
        </Grid>
        <Grid item xs={3}>
          <Link to="/services" className={clsx({
            [classes.navigationItem]: true,
            '--active': isPathActive(locationPathname, searchActivePath),
          })}>
            <div className={classes.navigationItemIcon}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0686 2.00002C8.79484 2.0006 7.53933 2.30268 6.40466 2.88156C5.26999 3.46045 4.28838 4.29971 3.54005 5.33074C2.79172 6.36178 2.29793 7.55531 2.09903 8.8138C1.90013 10.0723 2.00177 11.36 2.39564 12.5717C2.78952 13.7833 3.46444 14.8846 4.36525 15.7853C5.26606 16.6861 6.36719 17.3609 7.57861 17.7545C8.79004 18.1481 10.0774 18.2493 11.3354 18.0499C12.5934 17.8505 13.7865 17.3562 14.8169 16.6073L18.8372 20.6288C19.0748 20.8665 19.3971 21 19.7331 21C20.0691 21 20.3913 20.8665 20.6289 20.6288C20.8665 20.3911 21 20.0688 21 19.7327C21 19.3966 20.8665 19.0742 20.6289 18.8365L16.6086 14.815C17.4849 13.6102 18.0106 12.1862 18.1273 10.7009C18.2441 9.21553 17.9474 7.72685 17.2702 6.39983C16.5929 5.07282 15.5616 3.9593 14.2905 3.1827C13.0193 2.4061 11.558 1.99675 10.0686 2.00002ZM10.0686 15.6162C8.9729 15.6162 7.90184 15.2912 6.99083 14.6823C6.07982 14.0734 5.36978 13.2079 4.95049 12.1953C4.5312 11.1828 4.42149 10.0686 4.63524 8.99363C4.849 7.91869 5.37661 6.9313 6.15136 6.15631C6.92611 5.38132 7.9132 4.85355 8.9878 4.63973C10.0624 4.42592 11.1763 4.53565 12.1885 4.95507C13.2008 5.37449 14.066 6.08476 14.6747 6.99604C15.2834 7.90733 15.6083 8.97871 15.6083 10.0747C15.6066 11.5439 15.0225 12.9524 13.9839 13.9913C12.9454 15.0301 11.5373 15.6145 10.0686 15.6162Z" strokeWidth="0.5"/>
              </svg>
            </div>
            <div className={classes.navigationItemName}>{getTrans('header.Поиск')}</div>
          </Link>
        </Grid>
        <Grid item xs={3}>
          <Link to="/profile" className={clsx({
            [classes.navigationItem]: true,
            '--active': isPathActive(locationPathname, profileActivePath),
          })}>
            <div className={classes.navigationItemIcon}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7813 10.3125C14.7813 11.0604 14.5595 11.7914 14.144 12.4132C13.7285 13.0351 13.138 13.5197 12.447 13.8059C11.7561 14.0921 10.9958 14.167 10.2623 14.0211C9.52883 13.8752 8.85507 13.5151 8.32626 12.9862C7.79744 12.4574 7.43731 11.7837 7.29141 11.0502C7.14551 10.3167 7.22039 9.55641 7.50658 8.86548C7.79278 8.17454 8.27743 7.58399 8.89925 7.16851C9.52108 6.75302 10.2521 6.53125 11 6.53125C12.0025 6.53239 12.9636 6.93113 13.6725 7.64001C14.3814 8.34888 14.7801 9.31 14.7813 10.3125ZM19.9375 11C19.9375 12.7677 19.4133 14.4956 18.4313 15.9654C17.4492 17.4352 16.0534 18.5807 14.4202 19.2572C12.7871 19.9336 10.9901 20.1106 9.25638 19.7658C7.52268 19.4209 5.93017 18.5697 4.68024 17.3198C3.43031 16.0698 2.57909 14.4773 2.23424 12.7436C1.88938 11.0099 2.06637 9.21288 2.74283 7.57977C3.41929 5.94665 4.56483 4.55081 6.03459 3.56874C7.50436 2.58668 9.23233 2.0625 11 2.0625C13.3696 2.065 15.6414 3.00743 17.317 4.683C18.9926 6.35856 19.935 8.6304 19.9375 11ZM18.5625 11C18.5614 9.9821 18.355 8.97487 17.9557 8.03856C17.5564 7.10224 16.9724 6.25607 16.2386 5.55065C15.5048 4.84522 14.6362 4.29503 13.6849 3.93298C12.7335 3.57093 11.719 3.40446 10.7018 3.44352C6.65414 3.59992 3.42633 6.97125 3.4375 11.0215C3.44138 12.8653 4.12141 14.6436 5.34875 16.0196C5.84859 15.2946 6.48351 14.6729 7.21875 14.1883C7.28144 14.1469 7.35596 14.1272 7.43093 14.1321C7.50589 14.1371 7.57716 14.1665 7.63383 14.2158C8.56813 15.0239 9.76213 15.4686 10.9974 15.4686C12.2327 15.4686 13.4267 15.0239 14.361 14.2158C14.4177 14.1665 14.489 14.1371 14.5639 14.1321C14.6389 14.1272 14.7134 14.1469 14.7761 14.1883C15.5123 14.6726 16.1481 15.2944 16.6487 16.0196C17.8821 14.6386 18.5634 12.8516 18.5625 11Z"/>
              </svg>
            </div>
            <div className={classes.navigationItemName}>{getTrans('header.Профиль')}</div>
          </Link>
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    position: "fixed",
    bottom: 8,
    height: 52,
    display: "flex",
    borderRadius: 12,
    left: 8, right: 8,
    border: "1px solid",
    alignItems: "center",
    background: theme.palette.header.default,
    borderColor: theme.palette.header.default,
  },

  navigationItem: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",

    "&.--active": {
      "& $navigationItemIcon svg": {
        fill: theme.palette.primary.main,
      },
      "& $navigationItemName": {
        opacity: 1,
        color: theme.palette.primary.main,
      },
    }
  },
  navigationItemIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 22, height: 22,
    "& svg": {
      fill: theme.palette.text.primary,
    }
  },
  navigationItemName: {
    opacity: "0.6",
    marginTop: "2px",

    fontSize: 12,
    fontWeight: "500",
    lineHeight: "14px",
    textAlign: "center",
    color: theme.palette.text.primary,
  }
}));

export default Navigation
